import React from 'react';
import { Button, Form } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateApplicationDto,
  CreateUpdateClientDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface PolishNipPeselProps {
  client: CreateUpdateClientDto | CreateUpdateApplicationDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  findByNip?: (text: string) => void;
  readonly?: boolean;
}

export const PolishNipPesel: React.FC<PolishNipPeselProps> = props => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <>
      <FormRow controlId="nip" label={t(tk.client.nip)}>
        <div className="d-flex">
          <div className="flex-grow-1">
            <Form.Control
              type="text"
              value={props.client?.nip || ''}
              onChange={e =>
                props.propertyChange &&
                props.propertyChange({ nip: e.target.value?.trim() })
              }
              disabled={props.readonly}
            />
          </div>
          {!props.readonly && (
            <div className="flex-grow-0">
              <Button
                variant="outline-primary"
                onClick={() => {
                  if (props.findByNip && props.client.nip) {
                    props.findByNip(props.client.nip);
                  }
                }}
              >
                <Icon.Search /> GUS
              </Button>
            </div>
          )}
        </div>
      </FormRow>
      <FormRow controlId="pesel" label={t(tk.client.pesel)}>
        <div className="d-flex">
          <Form.Control
            type="text"
            value={props.client?.pesel || ''}
            onChange={e =>
              props.propertyChange &&
              props.propertyChange({ pesel: e.target.value?.trim() })
            }
            disabled={props.readonly}
          />
        </div>
      </FormRow>
    </>
  );
};
